
import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, Button, Card, CardBody, ModalFooter} from 'reactstrap';
import LoginComponent from './loginComponent.js'

var translator = require('../../utils/translator/translator.js');
var stateManager = require('../../utils/state/stateManager.js');
var loginDialogueAction = require('../../utils/state/actions/views/loginDialogue/loginDialogueAction');

class LoginDialogue extends Component 
{
    constructor(props) 
    {
        super(props);
        this.onLogin = this.onLogin.bind(this);
    }
    
    render()
    {
        let staffs = stateManager.getStore().getState().staffs
        return(<Modal isOpen={true} centered animation={false} fade={false} style={{minWidth:'55vh', maxWidth:'55vh'}}>
                    <ModalHeader cssModule={{ 'modal-title': 'w-100' }} style={{background:'var(--background-color)'}}>
                        <div className="caption primary-color d-flex justify-content-center" style={{marginTop:'5px', marginBottom:'-15px'}}>
                                {translator.getLabel("please_enter_your_pin")}
                        </div>
                    </ModalHeader>
                    <ModalBody style={{margin:'-10px', textAlign:'center', background:'var(--background-color)', marginTop:'1px', marginLeft:'2px', marginRight:'2px', marginBottom:'2px'}}>
                        <div className="d-flex justify-content-center">
                            <LoginComponent pinAllowed={this.props.pinAllowed} onLogin={this.onLogin} staffs={staffs}/>
                        </div>
                        <div className="d-flex justify-content-center" style={{paddingBottom:'20px', paddingTop:'5px'}}>
                            <Button className='btn-cancel' block onClick={this.onCancel}>{translator.getLabel("cancel")}</Button>
                        </div>
                    </ModalBody>
                </Modal>);
    }

    onLogin(iPinUsed, staff)
    {
        stateManager.getStore().dispatch(loginDialogueAction.createAction(null));
        this.props.onLogin(staff);
    }

    onCancel()
    {
        stateManager.getStore().dispatch(loginDialogueAction.createAction(null));
    }
}

export default LoginDialogue;